import React from 'react';

import ListPagePaginated from '@/src/shared/components/ListPage/ListPagePaginated';
import useListSearch from '@/src/shared/hooks/useListSearch';

const FederalUpdate = () => {
  const [loading, results] = useListSearch({
    pubCode: 791,
    yearsBack: 5,
  });

  return (
    <ListPagePaginated
      title="Federal Update"
      heroContent={<p>Documents from the last 5 years</p>}
      results={results}
      loading={loading}
    />
  );
};

export default FederalUpdate;
